import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ApiService } from '../../services/api.service';
import { MessageService } from 'primeng/api';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { Subscription } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-idex-prototype',
  standalone: false,
  templateUrl: './idex-prototype.component.html',
  styleUrl: './idex-prototype.component.scss',
})
export class IdexPrototypeComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  challengeForm!: FormGroup;
  proposalForm: FormGroup;
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Input() proposalName: any;
  @Input() proposalId: any;
  @Input() step: any;
  @Input() schemeType: any;
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Input() data: any[] = [];
  isEditMode: boolean = false;
  prototypeID: any;
  prototypeIDMake: any;
  Winnercols = [
    { field: 'rank', header: 'Rank', filterType: 'text' },
    { field: 'vendor.name', header: 'Name', filterType: 'text' },
    { field: 'total', header: 'Total marks obtained', filterType: 'text' },
    // { field: 'vendor.email', header: 'Contact Email', filterType: 'text', }
  ];
  shortlistedvendor: any;
  file: File;
  selectedFinalOfferFile: File | null = null;
  finalOfferFilePath: string | null = null;
  apiUrl = environment.APIUrl;
  private subscriptions = new Subscription();
  userID: any;
  selectedFinalOfferFiles: File[] = [];
  filesList: any;
  isSectionOpen: any = {
    prototypeScheduleDetails: false,
  };
  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private messageService: MessageService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    this.challengeForm = this.fb.group({
      projectDefinition: [''],
      preliminaryDesign: [''],
      detailedDesign: [''],
      fabricationBenefits: [''],
      testAnalysis: [''],
      integration: [''],
      performanceEvaluation: [''],
      // approvalDate: [null],
      deliveryDate: [null],
      prototypeDate: [null],
      delivery_location: [''],
    });
    if (this.schemeType == 'idex') {
      this.updateWinners();
    }
    this.getPrototype();
    //             if (this.isEditable) {
    //   // this.challengeForm.enable();
    //   this.editForm();
    // } else {
    //   this.challengeForm.disable();
    // }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.editForm();
      } else {
        this.isEditorDisabled = true;
        this.challengeForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }

  onUpload(event: any): void {
    const file = event.files?.[0];
    this.file = file;
    if (!file) return;
    this.selectedFinalOfferFile = file;
  }
  // Submission
  onSubmit(): void {
    if (this.challengeForm.valid) {
      // let payload = {
      //   proposal_step: this.step.id,
      //   project_definition: this.challengeForm.get('projectDefinition').value,
      //   preliminary_design: this.challengeForm.get('preliminaryDesign').value,
      //   detail_design: this.challengeForm.get('detailedDesign').value,
      //   fabrication_benefits: this.challengeForm.get('fabricationBenefits').value,
      //   analysis: this.challengeForm.get('testAnalysis').value,
      //   integration: this.challengeForm.get('integration').value,
      //   performance_evaluation: this.challengeForm.get('performanceEvaluation').value
      // }
      let formData = new FormData();

      formData.append('proposal_step', this.step.id);
      formData.append('project_definition',this.challengeForm.get('projectDefinition')?.value || '');
      formData.append('preliminary_design',this.challengeForm.get('preliminaryDesign')?.value || '');
      formData.append('detail_design',this.challengeForm.get('detailedDesign')?.value || '' );
      formData.append(  'fabrication_benefits',  this.challengeForm.get('fabricationBenefits')?.value || '');
      formData.append(  'analysis',  this.challengeForm.get('testAnalysis')?.value || '');
      formData.append( 'integration', this.challengeForm.get('integration')?.value || '');
      formData.append('performance_evaluation',this.challengeForm.get('performanceEvaluation')?.value || '');
      let url;
      if (this.schemeType == 'makeII' ||  this.schemeType == 'makeIII' ) {
        url = `/make1/make2/development/prototype/`;
        // if (this.file) formData.append('file', this.file);
      
      }else if (this.schemeType == 'makeI' ) {
        url = `/make1/development/prototype/`;
        // if (this.file) formData.append('file', this.file);
        
      } else if (this.schemeType == 'idex') {
        url = `/idex/development/prototype/`;
        if (this.file) formData.append('file', this.file);
      } else if (this.schemeType == 'tdf') {
        url = `/tdf/technology/prototype/`;
        if (this.file) formData.append('file', this.file);
      } else {
        url = `/revenue/development/prototype/`;
        //  if(this.file)
        // formData.append('file', this.file)
        // formData.append(   'approval_date',   this.challengeForm.get('approvalDate')?.value || '' );
        formData.append( 'delivery_date', this.challengeForm.get('deliveryDate')?.value || '' );
        formData.append(   'prototype_date',   this.challengeForm.get('prototypeDate')?.value || '' );
        formData.append(   'prototype_location',   this.challengeForm.get('delivery_location')?.value || '' );
        if (this.selectedFinalOfferFiles.length > 0) {
          this.selectedFinalOfferFiles.forEach((file) => {
            formData.append('prototype_files', file);
          });
        }
      }

      if (this.prototypeID) {
        const sub = this.api
          .putAPI(`${url}${this.prototypeID}/`, formData)
          .subscribe((res: any) => {
            if (res) {
              this.messageService.add({severity: 'success',summary: 'Success',detail: 'Form submitted sucessfully',
              });
              this.fileUpload?.clear();
              this.selectedFinalOfferFiles = [];
              this.selectedFinalOfferFile = null;
              this.finalOfferFilePath = null;
              this.getPrototype();
            }
          });
        this.subscriptions.add(sub);
      } else {
        const sub = this.api.postAPI(url, formData).subscribe((res: any) => {
          if (res) {
            this.messageService.add({severity: 'success',summary: 'Success',detail: 'Form submitted sucessfully',
            });
            this.fileUpload?.clear();
            this.selectedFinalOfferFile = null;
            this.finalOfferFilePath = null;
            this.selectedFinalOfferFiles = [];
            this.getPrototype();
          }
        });
        this.subscriptions.add(sub);
      }
    } else {
      console.warn('Form is invalid');
    }
  }
  // onSubmitMake():void{
  //   console.log("VENDOR OBJECT", this.vendorsFormObject);
  //   if (this.challengeForm.valid) {
  //     // let payload = {
  //     //   proposal_step: this.step.id,
  //     //   project_definition: this.challengeForm.get('projectDefinition').value,
  //     //   preliminary_design: this.challengeForm.get('preliminaryDesign').value,
  //     //   detail_design: this.challengeForm.get('detailedDesign').value,
  //     //   fabrication_benefits: this.challengeForm.get('fabricationBenefits').value,
  //     //   analysis: this.challengeForm.get('testAnalysis').value,
  //     //   integration: this.challengeForm.get('integration').value,
  //     //   performance_evaluation: this.challengeForm.get('performanceEvaluation').value
  //     // }
  //     let formData = new FormData();

  //     formData.append('proposal_step', this.step.id);
  //     formData.append('project_definition',this.challengeForm.get('projectDefinition')?.value || '');
  //     formData.append('preliminary_design',this.challengeForm.get('preliminaryDesign')?.value || '');
  //     formData.append('detail_design',this.challengeForm.get('detailedDesign')?.value || '' );
  //     formData.append(  'fabrication_benefits',  this.challengeForm.get('fabricationBenefits')?.value || '');
  //     formData.append(  'analysis',  this.challengeForm.get('testAnalysis')?.value || '');
  //     formData.append( 'integration', this.challengeForm.get('integration')?.value || '');
  //     formData.append('performance_evaluation',this.challengeForm.get('performanceEvaluation')?.value || '');
  //     let url;
  //     if (this.schemeType == 'makeII' ||  this.schemeType == 'makeIII' ) {
  //       url = `/make1/make2/development/prototype/`;
  //       // if (this.file) formData.append('file', this.file);
      
  //     }else if (this.schemeType == 'makeI' ) {
  //       url = `/make1/development/prototype/`;
  //       // if (this.file) formData.append('file', this.file);
        
  //     }  

  //     if (this.prototypeID) {
  //       const sub = this.api
  //         .putAPI(`${url}${this.prototypeID}/`, formData)
  //         .subscribe((res: any) => {
  //           if (res) {
  //             this.messageService.add({severity: 'success',summary: 'Success',detail: 'Form submitted sucessfully',
  //             });
  //             this.fileUpload?.clear();
  //             this.selectedFinalOfferFiles = [];
  //             this.selectedFinalOfferFile = null;
  //             this.finalOfferFilePath = null;
  //             this.getPrototype();
  //           }
  //         });
  //       this.subscriptions.add(sub);
  //     } else {
  //       const sub = this.api.postAPI(url, formData).subscribe((res: any) => {
  //         if (res) {
  //           this.messageService.add({severity: 'success',summary: 'Success',detail: 'Form submitted sucessfully',
  //           });
  //           this.fileUpload?.clear();
  //           this.selectedFinalOfferFile = null;
  //           this.finalOfferFilePath = null;
  //           this.selectedFinalOfferFiles = [];
  //           this.getPrototype();
  //         }
  //       });
  //       this.subscriptions.add(sub);
  //     }
  //   } else {
  //     console.warn('Form is invalid');
  //   }
  // }
  onSubmitMake(): void {

  console.log("VENDOR OBJECT", this.vendorsFormObject);

  // Convert vendor object to array
  // const vendorsArray = Object.values(this.vendorsFormObject);
  const vendorsArray = this.prepareVendorPayload();
  console.log("VENDORS ARRAY", vendorsArray);

  //  Prepare payload for backend
  const formData: any = {
    // prototype: this.prototypeID || null,
    proposal_step: this.step.id,
    vendors: vendorsArray   // <--- IMPORTANT
  };
  console.log("FORM DATA PAYLOAD", formData);

  let url = '';

  if (this.schemeType === 'makeII' || this.schemeType === 'makeIII') {
    url = `/make1/make2/development/prototype/`;
  }


  if (this.prototypeIDMake) {
    const sub = this.api.putAPI(`${url}${this.prototypeIDMake}/`, formData)
      .subscribe({
        next: (res: any) => {
          console.log("Updated Successfully", res);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully' });
        },
        error: (err: any) => {
          console.error("Update Error", err);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Update Failed' });
        }
      });

  } else {

    
    const sub = this.api.postAPI(url, formData)
      .subscribe({
        next: (res: any) => {
          console.log("Saved Successfully", res);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Saved Successfully' });
        },
        error: (err: any) => {
          console.error("Save Error", err);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Save Failed' });
        }
      });
  }
}
// prepareVendorPayload() {
//   return Object.values(this.vendorsFormObject).map((v: any) => {

//     return {
//       id: v.id || null,
//       vendor: v.vendor || null,
//       vendor_name: v.vendor_name || null,

//       project_definition: v.project_definition || null,
//       preliminary_design: v.preliminary_design || null,
//       detail_design: v.detail_design || null,
//       fabrication_benefits: v.fabrication_benefits || null,
//       analysis: v.analysis || null,
//       integration: v.integration || null,
//       performance_evaluation: v.performance_evaluation || null,

//       delivery_date: v.delivery_date || null,
//       prototype_date: v.prototype_date || null,
//     };
//   });
// }
// prepareVendorPayload() {
//   return Object.keys(this.vendorsFormObject).map(key => {
//     const v = this.vendorsFormObject[key];

//     return {
//       id: v.id || null,
//       // vendor: v.vendor || Number(key),    
//       // vendor_name: v.vendor_name || null,

//       project_definition: v.project_definition || null,
//       preliminary_design: v.preliminary_design || null,
//       detail_design: v.detail_design || null,
//       fabrication_benefits: v.fabrication_benefits || null,
//       analysis: v.analysis || null,
//       integration: v.integration || null,
//       performance_evaluation: v.performance_evaluation || null,

//       delivery_date: v.delivery_date || null,
//       prototype_date: v.prototype_date || null,
//     };
//   });
// }
prepareVendorPayload() {
  return Object.keys(this.vendorsFormObject).map(key => {
    const v = this.vendorsFormObject[key];

    return {
      id: v.id || null,
      vendor: v.vendor || null,
      vendor_name: v.vendor_name || null,

      project_definition: v.project_definition || null,
      preliminary_design: v.preliminary_design || null,
      detail_design: v.detail_design || null,
      fabrication_benefits: v.fabrication_benefits || null,
      analysis: v.analysis || null,
      integration: v.integration || null,
      performance_evaluation: v.performance_evaluation || null,

      development_prototype: v.development_prototype || null,

      delivery_date: v.delivery_date || null,
      prototype_date: v.prototype_date || null,
    };
  });
}




  editForm() {
    this.isEditMode = true;
    this.challengeForm.enable();
  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: 'Proposal Name', value: this.proposalName },
        {
          key: 'Project Definition',
          value: this.challengeForm.get('projectDefinition')?.value,
        },
        {
          key: 'Preliminary Design',
          value: this.challengeForm.get('preliminaryDesign')?.value,
        },
        {
          key: 'Detailed Design',
          value: this.challengeForm.get('detailedDesign')?.value,
        },
        {
          key: 'Fabrication/ Development Benefits',
          value: this.challengeForm.get('fabricationBenefits')?.value,
        },
        {
          key: 'Test and Analysis',
          value: this.challengeForm.get('testAnalysis')?.value,
        },
        {
          key: 'Integration',
          value: this.challengeForm.get('integration')?.value,
        },
        {
          key: 'Performance Evaluation',
          value: this.challengeForm.get('performanceEvaluation')?.value,
        },
      ],
    };

    this.generatePDFEmitter.emit(payload);
  }
  // getPrototype() {
  //   let url;
  //    if ( this.schemeType == 'makeII' ||  this.schemeType == 'makeIII' ) {
  //     url = `/make1/make2/development/prototype/?proposal_step=${this.step.id}&proposal_step__proposal=${this.proposalId}`;
    
  //    }else if ( this.schemeType == 'makeI' ) {
  //     url = `/make1/development/prototype/?proposal_step=${this.step.id}&proposal_step__proposal=${this.proposalId}`;
  //   } else if (this.schemeType == 'idex') {
  //     url = `/idex/development/prototype/?proposal_step=${this.step.id}&proposal_step__proposal=${this.proposalId}`;
  //   } else if (this.schemeType == 'tdf') {
  //     url = `/tdf/technology/prototype/?proposal_step=${this.step.id}&proposal_step__proposal=${this.proposalId}`;
  //   } else {
  //     url = `/revenue/development/prototype/?proposal_step=${this.step.id}&proposal_step__proposal=${this.proposalId}`;
  //   }
  //   const sub = this.api.getAPI(url).subscribe((res) => {
  //     this.prototypeID = res[0]?.id;
  //     if (res.length > 0) {
  //       this.challengeForm.patchValue({
  //         projectDefinition: res[0].project_definition,
  //         preliminaryDesign: res[0].preliminary_design,
  //         detailedDesign: res[0].detail_design,
  //         fabricationBenefits: res[0].fabrication_benefits,
  //         testAnalysis: res[0].analysis,
  //         integration: res[0].integration,
  //         performanceEvaluation: res[0].performance_evaluation,
  //         // approvalDate: res[0].approval_date,
  //         deliveryDate: res[0].delivery_date,
  //         prototypeDate: res[0].prototype_date,
  //       });
  //       if (this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
  //         this.shortlistedvendor = res.development_prototype;
  //         // this.finalOfferFilePath = res[0].file || null;
  //         console.log("makeII shortlisted vendor",this.shortlistedvendor);
        
  //       }else if ( this.schemeType == 'makeI') {
  //         this.shortlistedvendor = res.vendor || res[0].vendors ;
  //         this.finalOfferFilePath = res[0].file || null;
  //       } else if (this.schemeType == 'tdf') {
  //         this.shortlistedvendor = res[0].vendor || res.vendor;
  //         this.finalOfferFilePath = res[0].file || null;
  //       } else if (this.schemeType == 'revenue') {
  //         this.shortlistedvendor = res[0].vendors || res.vendor;
  //         this.filesList = res[0].prototype_files;
  //         this.finalOfferFilePath = res[0].file || null;
  //       } else if (this.schemeType == 'idex') {
  //         this.finalOfferFilePath = res[0].file || null;
  //       }
  //     }
  //   });
  //   this.subscriptions.add(sub);
  // }
  getPrototype() {
  let url;

  if (this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
    url = `/make1/make2/development/prototype/?proposal_step=${this.step.id}&proposal_step__proposal=${this.proposalId}`;
  } else if (this.schemeType == 'makeI') {
    url = `/make1/development/prototype/?proposal_step=${this.step.id}&proposal_step__proposal=${this.proposalId}`;
  } else if (this.schemeType == 'idex') {
    url = `/idex/development/prototype/?proposal_step=${this.step.id}&proposal_step__proposal=${this.proposalId}`;
  } else if (this.schemeType == 'tdf') {
    url = `/tdf/technology/prototype/?proposal_step=${this.step.id}&proposal_step__proposal=${this.proposalId}`;
  } else {
    url = `/revenue/development/prototype/?proposal_step=${this.step.id}&proposal_step__proposal=${this.proposalId}`;
  }

  const sub = this.api.getAPI(url).subscribe((res) => {

    // 🔥 SPECIAL CASE FOR makeII / makeIII (res is NOT an array here)
    if (this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      const arr = res?.development_prototype || [];

      // if (arr.length > 0) {
        if (res) {
        // const data = arr[0];
        const data = res;
        this.prototypeIDMake = data.id;
        this.shortlistedvendor = arr;
        console.log("testing", data, this.prototypeIDMake);
        arr.forEach((item: any) => {
        // this.vendorsFormObject[item.vendor] = item;
        this.vendorsFormObject[item.vendor] = {
          project_definition: item.project_definition || '',
          preliminary_design: item.preliminary_design || '',
          detail_design: item.detail_design || '',
          fabrication_benefits: item.fabrication_benefits || '',
          analysis: item.analysis || '',
          integration: item.integration || '',
          performance_evaluation: item.performance_evaluation || '',
          delivery_date: item.delivery_date || '',
          prototype_date: item.prototype_date || '',
          prototype_location: item.prototype_location || '',
          id: item.id,
          vendor: item.vendor,
          vendor_name: item.vendor_name,
        }
      })

      }

      return; // stop here so original logic stays untouched
    }

    // 🔥 ORIGINAL LOGIC (unchanged for all other schemes)
    this.prototypeID = res[0]?.id;

    if (res.length > 0) {
      this.challengeForm.patchValue({
        projectDefinition: res[0].project_definition,
        preliminaryDesign: res[0].preliminary_design,
        detailedDesign: res[0].detail_design,
        fabricationBenefits: res[0].fabrication_benefits,
        testAnalysis: res[0].analysis,
        integration: res[0].integration,
        performanceEvaluation: res[0].performance_evaluation,
        deliveryDate: res[0].delivery_date,
        prototypeDate: res[0].prototype_date,
        delivery_location: res[0].prototype_location || ''
      });

      if (this.schemeType == 'makeI') {
        this.shortlistedvendor = res.vendor || res[0].vendors;
        this.finalOfferFilePath = res[0].file || null;
      } else if (this.schemeType == 'tdf') {
        this.shortlistedvendor = res[0].vendor || res.vendor;
        this.finalOfferFilePath = res[0].file || null;
      } else if (this.schemeType == 'revenue') {
        this.shortlistedvendor = res[0].vendors || res.vendor;
        this.filesList = res[0].prototype_files;
        this.finalOfferFilePath = res[0].file || null;
      } else if (this.schemeType == 'idex') {
        this.finalOfferFilePath = res[0].file || null;
      }
    }

  });

  this.subscriptions.add(sub);
}


  totalRecords = 0;
  updateWinners(event: { page: number; search?: string } = { page: 1 }) {
    const url = `/idex/finalize/winner/?evaluation__proposal_step__proposal=${this.proposalId}&evaluation__proposal_step=${this.step.id}`;
    const sub = this.api.getAPI(url).subscribe((res: any) => {
      this.data = res.data;
      this.totalRecords = res.data.length;
    });
    this.subscriptions.add(sub);
  }
  extractFileName(path: string): string {
    const fileName = path.split('/').pop() || '';
    return fileName.length > 35 ? fileName.substring(0, 35) + '...' : fileName;
  }

  clearUpload() {
    this.selectedFinalOfferFile = null;
  }
  onUploadRev(event: any): void {
    const files = event.files;
    if (!files?.length) return;
    // Append new files to the array (avoid duplicates if needed)
    this.selectedFinalOfferFiles.push(...files);
  }
  removeFile(index: number): void {
    this.selectedFinalOfferFiles.splice(index, 1);
  }

  openFileInNewTab(file: File): void {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
    // Optional: revokeObjectURL after some time for memory cleanup
    setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
  }

  vendorsFormObject: any = {};
  lastVendorKey: any = null;
  
  sectionToggles(row: any) {
    if (this.lastVendorKey != null) this.saveVendorForm(this.lastVendorKey);      // save previous
    this.shortlistedvendor.forEach((v: any) => (v.isSectionOpen = false));        // close all
  
    row.isSectionOpen = !row.isSectionOpen;                                       // toggle current
    this.lastVendorKey = row.isSectionOpen ? row.vendor : null;                   // track open vendor
  
    if (row.isSectionOpen) this.setFormFromVendor(row.vendor);                    // load data if open
  }
  
  saveVendorForm(key: any) {
    this.vendorsFormObject[key] = {
      project_definition: this.challengeForm.get('projectDefinition')?.value || '',
      preliminary_design: this.challengeForm.get('preliminaryDesign')?.value || '',
      detail_design: this.challengeForm.get('detailedDesign')?.value || '',
      fabrication_benefits: this.challengeForm.get('fabricationBenefits')?.value || '',
      analysis: this.challengeForm.get('testAnalysis')?.value || '',
      integration: this.challengeForm.get('integration')?.value || '',
      performance_evaluation: this.challengeForm.get('performanceEvaluation')?.value || '',
      delivery_date: this.challengeForm.get('deliveryDate')?.value || '',
      prototype_date: this.challengeForm.get('prototypeDate')?.value || '',

      id: this.vendorsFormObject[key]?.id || null,
    };
  }
  
  setFormFromVendor(key: any) {
    const v = this.vendorsFormObject[key] || {};
    this.challengeForm.patchValue({
      projectDefinition: v.project_definition || '',
      preliminaryDesign: v.preliminary_design || '',
      detailedDesign: v.detail_design || '',
      fabricationBenefits: v.fabrication_benefits || '',
      testAnalysis: v.analysis || '',
      integration: v.integration || '',
      performanceEvaluation: v.performance_evaluation || '',
      deliveryDate: v.delivery_date || '',
      prototypeDate: v.prototype_date || '',
    });
  }
  
 

}
